export { URIObject } from './URIObject.ts'
// Can't just re-export because of https://github.com/parcel-bundler/parcel/issues/8748
import { Temporal as _Temporal } from '@js-temporal/polyfill'
import { default as _ky, HTTPError as _HTTPError } from 'ky'
export const Temporal = _Temporal
export const ky = _ky
export const HTTPError = _HTTPError
export * from './json.ts'
